

module.exports = __webpack_require__.stylable.create(
    "CompletedIcon1719786062",
    {"classes":{"root":"CompletedIcon1719786062__root","rootCircle":"CompletedIcon1719786062__rootCircle"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "CompletedIcon1719786062",
    null
);
